export default "__VITE_ASSET__6103fc30__"